import { Interface } from 'ethers/lib/utils.js';
import abi from '../abi';
import type { IConnectorReturnData } from '../types';
import type { BigNumber } from 'ethers';

export const withdrawToken = async (
	tokenAddress: string,
	withdrawFundsTokenAmount: BigNumber,
	walletAddress: `0x${string}`
): Promise<IConnectorReturnData> => {
	const target: string = 'Basic-v1';
	const synthethixInterface = new Interface(abi.scWalletBasic);
	const transferMarginEncodedData = synthethixInterface.encodeFunctionData('withdraw', [
		tokenAddress,
		withdrawFundsTokenAmount,
		walletAddress,
		0,
		0
	]);
	return {
		_target: target,
		_callData: transferMarginEncodedData
	};
};

export const addAuthority = async (walletAddress: `0x${string}`): Promise<IConnectorReturnData> => {
	const target: string = 'Auth-v1';
	const walletAuthorityInterface = new Interface(abi.scWalletAuth);
	const addAuthorityEncodedData = walletAuthorityInterface.encodeFunctionData('enable', [
		walletAddress
	]);
	return {
		_target: target,
		_callData: addAuthorityEncodedData
	};
};

export const removeAuthority = async (
	walletAddress: `0x${string}`
): Promise<IConnectorReturnData> => {
	const target: string = 'Auth-v1';
	const walletAuthorityInterface = new Interface(abi.scWalletAuth);
	const removeAuthorityEncodedData = walletAuthorityInterface.encodeFunctionData('disable', [
		walletAddress
	]);
	return {
		_target: target,
		_callData: removeAuthorityEncodedData
	};
};
